// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2iYwn","detailsBorder":"styles_detailsBorder__3orxo"};